export const LazyLoadedRoutes: string[] = [
  'auth',
  'dashboard',
  'create-event',
  'venue-list',
  'membership-edit',
  'add-membership',
  'membership-members',
  'venue-details',
  'venue-seatchart',
  'event-list',
  'event-details',
  'ticket-settings',
  'season-pass',
  'create-season-pass',
  'class-pass',
  'create-class-pass',
  'mark-seats-onhold',
  'attendee-questions',
  'suggested-square-items',
  'event-promoters',
  'plan',
  'order-form',
  'seating-chart',
  'boxoffice-app',
  'confirmation-delivery',
  'termsandconditions',
  'userandroles',
  'zapier',
  'css-editor',
  'conversion-tracking',
  'zoom-webinar',
  'zoom',
  'hubspot',
  'sales-force',
  'advanced-options',
  'audit-log',
  'edit-label',
  'embeddable-widget',
  // 'integromat',
  'mailchimp',
  'aweber',
  'smartwaiver',
  'mypasstracker',
  'integrately',
  'constant-contact',
  'sales-report',
  'mailchimp-report',
  'season-ticket-report',
  'membership-list',
  'account',
  'event-cancellation',
  'order-management',
  'attendee-management',
  'verify',
  'attendee-email-list',
  'add-email-attendees',
  'post-event-email',
  'view-recipients-list',
  'email-attendee',
  'donation-report',
  'square-merchandise-report',
  'seat-inventory',
  'print-badges',
  'order-list',
  'refund-requests',
  'sell-ticket',
  'sell-membership',
  'embed',
  'promocode',
  'social',
  'edit-promocode',
  'create-promocode',
  'exit-intent',
  'waitlist',
  'ticket-scan-report',
  'special-offers',
  'exportable-reports',
  'seating-chart-management',
  'ai-creator'
];
